// Tento soubor je "thin barrel" — implementace je ve složce `./object-workflow/`.
// Orientace: `./object-workflow/README.md`. Vstupní bod logiky: `workflow-model.ts`.

export * from './object-workflow';
